import { render, staticRenderFns } from "./Cenovnici.vue?vue&type=template&id=23e0f3f8&"
import script from "./Cenovnici.vue?vue&type=script&lang=js&"
export * from "./Cenovnici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports